import { render, staticRenderFns } from "./multipleCardsAssmats.vue?vue&type=template&id=210e8c47"
import script from "./multipleCardsAssmats.vue?vue&type=script&lang=js"
export * from "./multipleCardsAssmats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports